import { render } from "./KafedralarTopNChart.vue?vue&type=template&id=63784ecc&scoped=true"
import script from "./KafedralarTopNChart.vue?vue&type=script&lang=js"
export * from "./KafedralarTopNChart.vue?vue&type=script&lang=js"

import "./KafedralarTopNChart.vue?vue&type=style&index=0&id=63784ecc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63784ecc"]])

export default __exports__